import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Connect wallet',
    description: 'Select where you want to receive BTC',
  },
};
